export default {
  data() {
    return {
      pbState: null, // 0, "未开始"; 1, "正在评标"; 2, "定标"; 3, "终止评标"
    }
  },

  computed: {
    canSet() {
      return ['0', '1'].includes(this.pbState)
    }
  },

  created() {
    this.getPbState()
  },

  methods: {
    async getPbState() {
      try {
        const { data } = await this.$api.getProjectPbState();
        this.pbState = data.data;
      } catch(err) {
        console.error('getProjectPbState fail', err);
      }
    },
  }
}